// extracted by mini-css-extract-plugin
module.exports = {"topBar":"AdminLayout_topBar__2RnnR","logo":"AdminLayout_logo__3YsLV"};